import { BookingsApi } from '@linktivity/tata';
import config from '../config';

const bookingsApi = new BookingsApi(config);

export default bookingsApi;
